export const games = [
  {
    title: "Royal Chess",
    description: "Challenge the court wizard in a game of chess",
    players: "1 Player vs Wizard",
    type: "chess",
    difficulty: "hard"
  },
  {
    title: "Knights & Pawns", 
    description: "A classic game of strategy from the realm",
    players: "1 Player vs Knight",
    type: "checkers",
    difficulty: "medium"
  },
  {
    title: "Four Shields",
    description: "Align your shields to claim victory",
    players: "1 Player vs Squire",
    type: "connect4",
    difficulty: "medium"
  },
  {
    title: "Sword, Shield, Bow",
    description: "Test your wit against the royal guard",
    players: "1 Player vs Guard",
    type: "rockPaperScissors",
    difficulty: "easy"
  },
  {
    title: "Castle Defense",
    description: "Protect the castle walls from invasion",
    players: "1 Player",
    type: "castleDefense",
    difficulty: "medium"
  },
  {
    title: "Peasant's Cross",
    description: "A simple game played in taverns across the realm",
    players: "1 Player vs Innkeeper",
    type: "ticTacToe",
    difficulty: "easy"
  }
];